module.exports = __webpack_public_path__ + "img/freja-nyc_banner.6af475bf.jpg";